import React from "react";
import useCompanyUsers from "@/hooks/companies/useCompanyUsers";
import i18n from "@/i18n";

import Select from "@/components/select";

const { t } = i18n;

const UserCommReplyToSelect = ({ value, onChange, disabled }) => {
  const { data: companyUsersQuery, isLoading: isLoadingCompanyUsers } =
    useCompanyUsers();
  const companyUsers = companyUsersQuery?.data;
  const allowedReplyToEmails = [
    {
      name: "No reply",
      email: "no-reply@invono.se",
      verified: true,
    },
    ...(companyUsers
      ?.flatMap?.((user) =>
        user.emails.map((email) => ({
          email: email.email,
          verified: email.verified,
          name: user.name,
        })),
      )
      .filter((e) => e.verified)
      .map((e) => e) ?? []),
  ];

  const options = allowedReplyToEmails?.map((e) => ({
    value: e.email,
    label: (
      <div className="flex gap-4">
        {e.email} <span className="text-slate-500">({e.name})</span>
      </div>
    ),
  }));

  return (
    <Select
      label={t("user_comms.reply_to.label")}
      hint={t("user_comms.reply_to.hint")}
      className="min-w-[300px]"
      disabled={disabled}
      isLoading={isLoadingCompanyUsers}
      options={options}
      value={value}
      onChange={onChange}
    />
  );
};

export default UserCommReplyToSelect;
